import React, {memo, useState, useCallback, useEffect} from "react"
import {PasswordContainer} from "../../../../../components/PasswordContainer"
import {useHistory} from "react-router-dom"
import {useMessage} from "../../../../../hooks/message"
import {useRPC} from "../../../../../hooks/rpc"
import backIcon from "../../../../../assets/images/icons/alarm/cancel.png"
import plusIcon from "../../../../../assets/images/icons/controls/plus.png"
import minusIcon from "../../../../../assets/images/icons/controls/minus.png"
import {useSelector} from "react-redux"
import {SoundPlayingStatus} from "../../../../../store/control/state"
import {useDebounce} from "../../../../../hooks/debounce"
import "./index.scss"

export const SoundTestScreen = memo(function SoundTestScreen() {
    const history = useHistory()
    const {success} = useMessage()
    const [rpc] = useRPC()
    const [startStopRecording, setStartStopRecording] = useState(false)
    const [playPauseRecording, setPlayPauseRecording] = useState(false)
    const [play1, setPlay1] = useState(false)
    const [play2, setPlay2] = useState(false)
    const [play3, setPlay3] = useState(false)
    const [timer, setTimer] = useState(60)
    const [records, setRecords] = useState<SoundPlayingStatus>(null)
    const [soundLevel, setSoundLevel] = useState(records?.sound_level || 50)
    const [microphoneLevel, setMicrophoneLevel] = useState(records?.mic_level || 50)
    const [savedRecord, setSavedRecord] = useState(0)
    const playingStatus = useSelector(state => state.control.soundPlayingStatus)

    useEffect(() => {
        rpc.getTestSounds().then(r => setRecords(r))
    }, [rpc])
    const onClickStartStopRecording = useCallback(
        (type: number) => {
            switch (type) {
                case 1:
                    let newStartStop = startStopRecording
                    if (newStartStop) {
                        newStartStop = false
                    } else {
                        newStartStop = true
                    }
                    setStartStopRecording(newStartStop)
                    setPlay1(false)
                    setPlay2(false)
                    setPlay3(false)
                    setPlayPauseRecording(false)
                    if (timer <= 59) {
                        setTimer(60)
                        setSavedRecord(60 - timer)
                        success(`Ses başarıyla kaydedildi! (00:${60 - timer}) `)
                    }
                    rpc.recordTestSound(newStartStop)
                    break
                case 2:
                    let newPlay1 = play1
                    if (newPlay1) {
                        newPlay1 = false
                    } else {
                        newPlay1 = true
                    }
                    setPlay1(newPlay1)
                    setStartStopRecording(false)
                    setPlay2(false)
                    setPlay3(false)
                    setPlayPauseRecording(false)
                    rpc.playTestSound(90, newPlay1 ? "play" : "stop")
                    break

                case 3:
                    let newPlay2 = play2
                    if (newPlay2) {
                        newPlay2 = false
                    } else {
                        newPlay2 = true
                    }
                    setPlay2(newPlay2)
                    setStartStopRecording(false)
                    setPlay1(false)
                    setPlay3(false)
                    setPlayPauseRecording(false)
                    rpc.playTestSound(91, newPlay2 ? "play" : "stop")
                    break

                case 4:
                    let newPlay3 = play3
                    if (newPlay3) {
                        newPlay3 = false
                    } else {
                        newPlay3 = true
                    }

                    setPlay3(newPlay3)
                    setStartStopRecording(false)
                    setPlay1(false)
                    setPlay2(false)
                    setPlayPauseRecording(false)
                    rpc.playTestSound(92, newPlay3 ? "play" : "stop")
                    break

                case 5:
                    let newPlay4 = playPauseRecording
                    if (newPlay4) {
                        newPlay4 = false
                    } else {
                        newPlay4 = true
                    }
                    setPlayPauseRecording(newPlay4)
                    setStartStopRecording(false)
                    setPlay1(false)
                    setPlay2(false)
                    setPlay3(false)
                    rpc.playTestSound(93, newPlay4 ? "play" : "stop")
                    break

                default:
                    setStartStopRecording(false)
                    setPlay1(false)
                    setPlay2(false)
                    setPlay3(false)
                    setPlayPauseRecording(false)
                    break
            }
        },
        [success, rpc, timer, play1, play2, play3, playPauseRecording, startStopRecording]
    )
    const onClickSoundLevel = useDebounce((type: "dec" | "inc") => {
        let newSoundLevel = soundLevel
        switch (type) {
            case "dec":
                if (newSoundLevel === 0) {
                    return (newSoundLevel = 0)
                }
                newSoundLevel -= 10
                break
            case "inc":
                if (newSoundLevel === 100) {
                    return (newSoundLevel = 100)
                }
                newSoundLevel += 10
                break
            default:
                newSoundLevel = 50
                break
        }
        setSoundLevel(newSoundLevel)
        rpc.setSoundLevelOnTestPage(newSoundLevel)
    }, 100)

    const onClickMicrophoneLevel = useDebounce((type: "dec" | "inc") => {
        let newMicrophoneLevel = microphoneLevel
        switch (type) {
            case "dec":
                if (newMicrophoneLevel === 0) {
                    return (newMicrophoneLevel = 0)
                }
                newMicrophoneLevel -= 10
                break
            case "inc":
                if (newMicrophoneLevel === 100) {
                    return (newMicrophoneLevel = 100)
                }
                newMicrophoneLevel += 10
                break
            default:
                newMicrophoneLevel = 50
                break
        }
        setMicrophoneLevel(newMicrophoneLevel)
        rpc.setMicLevelOnTestPage(newMicrophoneLevel)
    }, 100)

    useEffect(() => {
        setSoundLevel(records?.sound_level)
        setMicrophoneLevel(records?.mic_level)
    }, [records])

    useEffect(() => {
        if (!playingStatus?.play_status) {
            setPlayPauseRecording(false)
            setPlay1(false)
            setPlay2(false)
            setPlay3(false)
        }
    }, [playingStatus])

    useEffect(() => {
        let newTimer = timer
        if (startStopRecording) {
            const interval = setInterval(() => {
                newTimer--
                if (newTimer >= 1) {
                    setTimer(newTimer)
                } else {
                    setSavedRecord(60 - newTimer)
                    setStartStopRecording(false)
                    success(`Ses başarıyla kaydedildi! (00:${60 - newTimer}) `)
                    setTimer(60)
                }
            }, 1000)
            return () => clearInterval(interval)
        }
    }, [success, timer, startStopRecording, rpc])

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <div className="sound-test-container">
                <div className="sound-test-top" onClick={() => history.push("/settings/advanced-settings/test")}>
                    <img src={backIcon} alt="" />
                </div>
                <div className="sound-test-screen sound-test-left">
                    <div className="sound-test-title">Ses Giriş Testi</div>
                    <div className="sound-test-button-container">
                        <button
                            onClick={() => onClickStartStopRecording(1)}
                            disabled={play1 || play2 || play3 || playPauseRecording}
                        >
                            {startStopRecording ? "Kaydı Durdur" : "Kayıt Başlat"}
                        </button>
                    </div>
                    <div className="sound-test-texts">
                        <span>SES</span>
                        <span>MİKROFON</span>
                    </div>
                    <div className="sound-test-set-actions">
                        <div className="sound-test-set">
                            <span onClick={() => onClickSoundLevel("inc")}>
                                <img src={plusIcon} alt="" />
                            </span>
                            <span>{soundLevel}</span>
                            <span onClick={() => onClickSoundLevel("dec")}>
                                <img src={minusIcon} alt="" />
                            </span>
                        </div>
                        <div className="sound-test-timer">
                            <span>'{timer}</span>
                        </div>
                        <div className="sound-test-set">
                            <span onClick={() => onClickMicrophoneLevel("inc")}>
                                <img src={plusIcon} alt="" />
                            </span>
                            <span>{microphoneLevel}</span>
                            <span onClick={() => onClickMicrophoneLevel("dec")}>
                                <img src={minusIcon} alt="" />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="sound-test-screen sound-test-right">
                    <div className="sound-test-title">Ses Çıkış Testi</div>
                    <div className="sound-test-action">
                        <span>{"Ses 1"}</span>
                        <div className="sound-test-action-buttons">
                            <button
                                onClick={() => onClickStartStopRecording(2)}
                                disabled={startStopRecording || playPauseRecording || play3 || play2}
                            >
                                {play1 ? "Durdur" : "Oynat"}
                            </button>
                        </div>
                    </div>
                    <div className="sound-test-action">
                        <span>{"Ses 2"}</span>
                        <div className="sound-test-action-buttons">
                            <button
                                onClick={() => onClickStartStopRecording(3)}
                                disabled={startStopRecording || playPauseRecording || play3 || play1}
                            >
                                {play2 ? "Durdur" : "Oynat"}
                            </button>
                        </div>
                    </div>
                    <div className="sound-test-action">
                        <span>{"Ses 3"}</span>
                        <div className="sound-test-action-buttons">
                            <button
                                onClick={() => onClickStartStopRecording(4)}
                                disabled={startStopRecording || playPauseRecording || play2 || play1}
                            >
                                {play3 ? "Durdur" : "Oynat"}
                            </button>
                        </div>
                    </div>
                    <div className="sound-test-saved">
                        <span>{savedRecord === 0 ? "Kaydedilen Ses" : `${"00:" + savedRecord}`}</span>
                        <div className="sound-test-action-saved">
                            <button
                                onClick={() => onClickStartStopRecording(5)}
                                disabled={startStopRecording || play3 || play2 || play1}
                            >
                                {playPauseRecording ? "Durdur" : "Oynat"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </PasswordContainer>
    )
})
